import { cn } from '@/utils/shadcn/utils'

export function StatCardContainer({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'bg-background border border-primary-border rounded-lg py-3 px-4 w-full flex-1',
        'min-w-fit',
        className,
      )}
    >
      {children}
    </div>
  )
}

export function StatCardLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-moment-grey-800 dark:text-moment-grey-200 text-left">
      {children}
    </div>
  )
}

export function StatCardValue({ children }: { children: React.ReactNode }) {
  return <div className="text-left">{children}</div>
}
